<template>
    <section class="error-404">
        <div class="container">
            <div class="left">
                <img src="images/error-404.jpg" />
            </div>
            <div class="right">
                <h1>{{ $t('not_found.title') }}</h1>
                <p>{{ $t('not_found.info') }}</p>
                <a class="btn btn-primary" href="/">{{ $t('nav.catalog') }}</a>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'Error404',
        components: {}
    }
</script>